module.exports = __webpack_public_path__ + "img/accreditation-asata.48ff5319.png";